module.exports = __webpack_public_path__ + "media/images/menu/norma-77227c26568f699e08931c7a970fa145.jpg";